<template>
  <b-container fluid>

    <!-- TODO: this will become the dashboard! -->
    <!-- TODO: create panels or lists to be added this this page, etc -->
    <!-- we can hardcode some for now -->
    <b-row no-gutters>
      <b-card no-body :class="dashboard.CardClass" class="my-2" v-for="dashboard in dashboards" :key="dashboard.DashboardId">
        <!-- TODO: toggle editor open? -->
        <!-- @click="toggleEditorSectionOpen({ section })" -->
        <!-- TOOD: pass multiple here even if it isn't? -->
        <b-card-header>
          {{ dashboard.DisplayName }}
        </b-card-header>
        <b-card-body class="p-0 loading-card" v-if="dashboard.loading">
          <b-spinner
            style="width: 5rem; height: 5rem; border-width: 0.4rem; margin: auto 0"
            label="Large Spinner"
            class="c-spinner">
          </b-spinner>
        </b-card-body>
        <b-card-body class="p-0" v-else>
          <p class="m-3" v-if="dashboard.results.Total === 0">No records are present.</p>
          <b-table striped hover small sticky-header :items="dashboard.results.List" :fields="dashboard.fields" v-if="dashboard.results.Total > 0">
            <!-- note: this is a specific override for Deliveries -->
            <!-- !important:
                when making this a sub-component:
                you can take this as a slot to put in the slot
                do not hardcode
              -->
            <template #cell(OrderDate)="data">
              <div class="p-2 pl-3">
                <b-icon icon="circle-fill" v-if="data.value" :variant="data.value" />
                {{ dayjs(data.item.OrderDate).format('YYYY-MM-DD') }}
              </div>
            </template>
            <template #cell(SalesOrderNumber)="data">
              <router-link :to="{ name: 'order_summary', params: { invoiceNo: data.value } }">
                {{ data.value }}
              </router-link><br />
              <!-- {{ dayjs(data.item.OrderDate).format('YYYY-MM-DD') }} -->
              {{ data.item.CustomerPurchaseOrderNumber }}
            </template>
            <template #cell(Creator)="data">
              {{ data.item.Creator && data.item.Creator.length > 0 ? data.item.Creator : data.item.CreatorUsername }}
            </template>
            <template #cell(CustomerNumber)="data">
              <router-link :to="{ name: 'customer', params: { customerNumber: data.value } }">
                {{ data.value }}
              </router-link><br />
              {{ data.item.CustomerName }}
            </template>
            <template #cell(ShipToParty)="data">
              {{ data.value.Name }}<br />
              {{ data.value.City }}, {{ data.value.State }}, {{ data.value.Zip }}
            </template>
            <template #cell(SalesRepresentatives)="data">
              {{ data.value.join(', ') }}<br />
            </template>
            <!-- TODO: Id is too generic -->
            <template #cell(Id)="data">
              <router-link :to="{ name: 'sales-rep-profile', params: { salesRepNumber: data.value } }">
                {{ data.value }}
              </router-link><br />
              {{ data.item.Name }}
            </template>
            <template v-slot:cell(InquiryId)="{ item }">
              <router-link
                :to="{
                  name: 'inquiry_summary',
                  params: { inquiryId: item.InquiryId + '' },
                }"
                class="order-link"
              >
                {{ item.InquiryId }}
              </router-link>
            </template>
            <template v-slot:cell(Deliveries)="{ item }">
              <div
                class="d-flex align-items-center"
                v-if="item.Deliveries != null && item.Deliveries.length > 0"
              >
                <b-icon icon="truck" variant="info" class="mr-2" />
                <div>
                  <template v-for="delivery in item.Deliveries.slice(0,2)">
                    <template v-if="delivery.ShippingInformation && delivery.ShippingInformation.TrackingUpdatesList?.length > 0">
                      <b-button
                        @click="() => setSelectedShippingInformation(delivery.ShippingInformation, delivery.TrackingNumber)"
                        variant="link p-0"
                        :key="delivery.DeliveryId"
                        >{{ delivery.Carrier }}</b-button
                      >
                    </template>
                    <template v-else>
                      {{ delivery.Carrier }}
                    </template>
                  </template>
                </div>
                <div v-if="item.Deliveries != null && item.Deliveries.length > 2"> + {{ item.Deliveries.length-2 }}</div>
              </div>
              <div
                class="d-flex align-items-center"
                v-else-if="item.ExpectedShippingDate"
              >
                <p title="Expected Shipping Date">
                  {{ formatDate(item.ExpectedShippingDate) }}
                </p>
              </div>
            </template>
            <template v-slot:cell(Customer)="{ item }">
              <div class="d-flex align-items-center">
                <b-icon icon="shop" variant="info" class="mr-2" />
                <div>
                  <router-link
                    :to="'/customer/'+item.CustomerNumber"
                    class="order-link"
                  >
                    {{ item.CustomerNumber }}
                  </router-link>
                  <br />
                  {{ item.CustomerName }}
                </div>
              </div>
            </template>
            <template v-slot:cell(Material)="{ item }">
              <div class="align-items-center">
                <div>
                  <div class="font-weight-bold">
                    {{ item.Items.length }} items(s)
                  </div>
                  <div v-for="i in item.Items.slice(0, 2)" :key="i.ItemNumber">
                    <div class="row mt-1">
                      <div class="col-sm-3 text-wrap text-break">
                        {{ i.MaterialNumber }}
                      </div>
                      <div class="col-sm-7 text-wrap text-break">
                        {{ i.Description }}
                      </div>
                      <div class="col-sm-2 text-wrap text-break">
                        {{ i.Quantity }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="" v-if="item.Items.length > 2"><b>+More</b></div>
              </div>
            </template>
            <template #cell(PendingPermissionRequests)="data">
              <b-table-simple borderless small responsive class="mb-0">
                <b-tbody>
                  <b-tr v-for="request in data.value" :key="request.Id">
                    <b-td>
                      <strong>{{ request.UserName }}</strong>
                      <b-button-toolbar class="float-md-right">
                        <b-button-group size="sm" class="mx-1">
                          <b-button class="mr-1" variant="outline-success" @click="onApproveSalesRep(request)">
                            <b-icon icon="check-circle" /> Approve
                          </b-button>
                          <b-button variant="outline-danger" @click="onRejectSalesRep(request)">
                            <b-icon icon="x-circle" /> Reject
                          </b-button>
                        </b-button-group>
                      </b-button-toolbar>
                    </b-td>
                  </b-tr>
                </b-tbody>

              </b-table-simple>
            </template>
            <template #cell(PendingCustomerPermissionRequests)="data">
              <b-table-simple borderless small responsive class="mb-0">
                <b-tbody>
                  <b-tr v-for="request in data.value" :key="request.Id">
                    <b-td>
                      <template v-if="!_isSalesRepSite(site.Name) && request.Status === 5">
                        <strong>Waiting for Sales Rep Approval</strong>
                      </template>
                      <template v-else>
                        <strong>{{ request.UserEmail }}</strong>
                        <b-button-toolbar class="float-md-right">
                          <b-button-group size="sm" class="mx-1">
                            <b-button class="mr-1" variant="outline-success" @click="onApproveCustomer(request)">
                              <b-icon icon="check-circle" /> Approve
                            </b-button>
                            <b-button variant="outline-danger" @click="onRejectCustomer(request)">
                              <b-icon icon="x-circle" /> Reject
                            </b-button>
                          </b-button-group>
                        </b-button-toolbar>
                      </template>
                    </b-td>
                  </b-tr>
                </b-tbody>

              </b-table-simple>
            </template>
          </b-table>
          <!-- <b-container fluid>
              <b-row v-for="(result, i) in dashboard.results.List" :key="i">
                <b-col>{{result.SalesOrderNumber}}</b-col>
                <b-col :variant="'danger'">{{result.OrderDate}}</b-col>
              </b-row>
              STUFF
            </b-container> -->
        </b-card-body>
        <b-card-footer v-if="dashboard.results.Total > 0">
          {{ getResultCount(dashboard) }}
        </b-card-footer>
      </b-card>
    </b-row>

    <b-modal v-if="showSalesRepRejectionModal && salesRepRequestToReject" title="Please add the reason to reject" v-model="showSalesRepRejectionModal" size="sm" centered no-close-on-backdrop @cancel="showSalesRepRejectionModal = false" @close="showSalesRepRejectionModal = false" @ok="rejectPermissionSalesRep">
      <div>
        <p>
          <b>Sales Representative Number:</b> {{ salesRepRequestToReject.SalesRepresentativeNumber }}
        </p>
        <p>
          <b>Sales Representative Name:</b> {{ salesRepRequestToReject.SalesRepresentativeName }}
        </p>
        <p>
          <b>User Email:</b> {{ salesRepRequestToReject.UserEmail }}
        </p>
        <b-form-group label="Rejection reason*" label-for="rejection-reason">
          <b-form-input id="rejection-reason" v-model="rejectionReason" placeholder="Rejection reason" :state="isValidRejectionReason()"></b-form-input>
          <b-form-invalid-feedback>Please add a rejection reason</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal v-if="showSalesRepApproveModal && salesRepRequestToApprove" title="Are you sure you want to approve?" v-model="showSalesRepApproveModal" size="sm" centered no-close-on-backdrop @cancel="showSalesRepApproveModal = false" @close="showSalesRepApproveModal = false" @ok="approvePermissionSalesRep">
      <div>
        <p>
          <b>Sales Representative Number:</b> {{ salesRepRequestToApprove.SalesRepresentativeNumber }}
        </p>
        <p>
          <b>Sales Representative Name:</b> {{ salesRepRequestToApprove.SalesRepresentativeName }}
        </p>
        <p>
          <b>User Email:</b> {{ salesRepRequestToApprove.UserEmail }}
        </p>
      </div>
    </b-modal>

    <b-modal v-if="showCustomerRejectionModal && customerRequestToReject" title="Please add the reason to reject" v-model="showCustomerRejectionModal" size="sm" centered no-close-on-backdrop @cancel="showCustomerRejectionModal = false" @close="showCustomerRejectionModal = false" @ok="rejectPermissionCustomer">
      <div>
        <p>
          <b>Customer Number:</b> {{ customerRequestToReject.CustomerNumber }}
        </p>
        <p>
          <b>Customer Name:</b> {{ customerRequestToReject.CustomerName }}
        </p>
        <p>
          <b>User Email:</b> {{ customerRequestToReject.UserEmail }}
        </p>
        <b-form-group label="Rejection reason*" label-for="rejection-reason">
          <b-form-input id="rejection-reason" v-model="rejectionReason" placeholder="Rejection reason" :state="isValidRejectionReason()"></b-form-input>
          <b-form-invalid-feedback>Please add a rejection reason</b-form-invalid-feedback>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal v-model="showCustomerApproveModal" v-if="customerRequestToApprove != null" title="Are you sure you want to approve?" size="sm" centered no-close-on-backdrop @cancel="showCustomerApproveModal = false" @close="showCustomerApproveModal = false" @ok="approvePermissionCustomer">
      <div>
        <p>
          <b>Customer Number:</b> {{ customerRequestToApprove.CustomerNumber }}
        </p>
        <p>
          <b>Customer Name:</b> {{ customerRequestToApprove.CustomerName }}
        </p>
        <p>
          <b>User Email:</b> {{ customerRequestToApprove.UserEmail }}
        </p>
      </div>
    </b-modal>
    <order-tracking
      :shippingInformation="selectedShippingInformation"
      :trackingNumber="selectedTrackingNumber"
      @close="() => { selectedShippingInformation = undefined;  selectedTrackingNumber = ''}"
    ></order-tracking>
  </b-container>
</template>

<script lang="ts">
import { Component, Mixins, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import dayjs from 'dayjs'

// TODO: MxOrders?
import MxSite from '@/mixins/site'
import { IDashboard, ISearchFilters, ShippingInformation } from '@/store/orders/types'

import LoadingText from '@/components/utility/loading-text.vue'
import { blankSearchFilters, OrderStatus } from '@/store/orders/constants'
import { blankSearchFilters as blankInquiryFilters } from '@/store/inquiry/constants'
import OrderTracking from '@/components/order-tracking/order-tracking.vue'
import { isMobile, handleResize } from '@/common/helpers/responsive-helper'
import { Api } from '@/api/Api'
import _ from 'lodash'

import { blankResponseArray } from '@/store/constants'
import { HttpMethod } from '@/api/FetchApi'
import { isCustomerAdminSite } from '@/helpers/sites.helper'
import { TPIException } from '@/store/editor/types'

const nsOrders = namespace('orders')
const nsInquiries = namespace('inquiries')
const nsOrderState = namespace('order-state')

@Component({
  components: {
    'loading-text': LoadingText,
    'order-tracking': OrderTracking,
  },
})
export default class extends Mixins(MxSite) {
  public dayjs = dayjs

  public api = new Api()

  public sortOptions: { by: string; desc: boolean } = {
    by: 'OrderDate',
    desc: true,
  }

  @nsOrders.Action('getOrders')
  private getOrders: any

  @nsInquiries.Action('getInquiries')
  private getInquiries: any

  @nsOrders.Action('getCustomerApprovals')
  private getCustomerApprovals : any

  @nsOrders.Action('approvePermissionCustomerAction')
  private approvePermissionCustomerAction : any

  @nsOrders.Action('rejectPermissionCustomerAction')
  private rejectPermissionCustomerAction : any

  @nsOrders.Action('fetchOrder')
  private fetchOrder: any

  @nsOrderState.Action('resetOrder')
  private resetOrder: any

  @nsOrders.State('searchFilters')
  public searchFilters!: ISearchFilters

  public isMobile = isMobile()

  public rejectionReason: string | null = null
  public showSalesRepRejectionModal = false
  public showSalesRepApproveModal = false
  public showCustomerRejectionModal = false
  public showCustomerApproveModal = false
  public salesRepRequestToReject: { Id: string, UserEmail: string, SalesRepresentativeName: string, SalesRepresentativeNumber: string } | null = null
  public salesRepRequestToApprove: { Id: string, UserEmail: string, SalesRepresentativeName: string, SalesRepresentativeNumber: string } | null = null
  public customerRequestToReject: { Id: string, UserEmail: string, CustomerName: string, CustomerNumber: string } | null = null
  public customerRequestToApprove: { Id: string, UserEmail: string, CustomerName: string, CustomerNumber: string } | null = null

  public selectedShippingInformation: ShippingInformation | any = { isBlank: true }
  public selectedTrackingNumber = ''

  public created() {
    handleResize((isMobile) => {
      this.isMobile = isMobile
    })

    if (this._isCustomerAdminSite()) {
      this.dashboards.push(this.dashboardPendingOrders)
      this.dashboards.push(this.dashboardInquiryPending)
      this.dashboards.push(this.dashboardSalesRepRequests)
      this.dashboards.push(this.dashboardCustomerRequests)
    } else if (this._isSalesRepSite(this.site.Name)) {
      this.dashboards.push(this.dashboardShippedOrders)
      this.dashboards.push(this.dashboardSalesRepCustomerRequests)
    } else if (this._isCustomerSite(this.site.Name)) {
      this.dashboards.push(this.dashboardShippedOrders)
      this.dashboards.push(this.dashboardInquiryPending)
    }
  }

  // TODO: store these in the DB!
  public dashboards: IDashboard[] = []

  public dashboardPendingOrders = {
    DashboardId: 1, // TODO: will be TitleCase if it comes from the DB
    Name: 'PendingOrders',
    DisplayName: 'Pending Sales Orders',
    Entity: 'Order', // TODO: this should be more about what to call to get the results
    Method: 'getFilteredOrders',
    Filter: { orderStatus: OrderStatus.PENDING },
    CardClass: 'col-12',
    fields: [
      {
        label: 'Date',
        class: '',
        thClass: 'pl-3',
        key: 'OrderDate',
        formatter: (val: string) => {
          if (!val) return ''
          const orderDate = dayjs(val)
          if (dayjs().diff(orderDate, 'days') > 7) {
            return 'danger'
          } else if (dayjs().diff(orderDate, 'days') > 1) {
            return 'warning'
          } else {
            return 'success'
          }
        },
      },
      { label: 'Order/PO', class: '', key: 'SalesOrderNumber' },
      // { label: 'Order Date', class: '', key: 'OrderDate', formatter: (val: string) => dayjs(val).format('YYYY-MM-DD') },
      // { label: 'PO', class: '', key: 'CustomerPurchaseOrderNumber' },
      { label: 'Customer', class: '', key: 'CustomerNumber' },
      { label: 'Ship To', class: '', key: 'ShipToParty' },
      { label: 'Creator', class: '', key: 'Creator' },
      // { label: 'Sales Reps', class: '', key: 'SalesRepresentatives' },
      { label: 'Amount', class: 'text-sm-right', key: 'Total', formatter: (val: string) => this.formatPrice(val) },
    ],
    results: _.clone(blankResponseArray),
  }

  public dashboardSalesRepRequests = {
    DashboardId: 4, // TODO: will be TitleCase if it comes from the DB
    Name: 'SalesRepApprovalRequests',
    DisplayName: 'SalesRep Approval Requests',
    Entity: 'User', // TODO: this should be more about what to call to get the results
    Method: 'getSalesRepApprovals',
    Filter: {},
    CardClass: 'col-6',
    fields: [
      { label: 'Sales Rep', class: '', key: 'Id' },
      { label: 'Pending Requests', class: '', key: 'PendingPermissionRequests' },
    ],
    results: _.clone(blankResponseArray),
  }

  public dashboardCustomerRequests = {
    DashboardId: 5, // TODO: will be TitleCase if it comes from the DB
    Name: 'CustomerApprovalRequests',
    DisplayName: 'Customer Approval Requests',
    Entity: 'User', // TODO: this should be more about what to call to get the results
    Method: 'getCustomerApprovals',
    Filter: {},
    CardClass: 'col-6',
    fields: [
      { label: 'Customer No', class: '', key: 'CustomerNumber' },
      { label: 'Pending Requests', class: '', key: 'PendingCustomerPermissionRequests' },
    ],
    results: _.clone(blankResponseArray),
  }

  public dashboardSalesRepCustomerRequests = {
    DashboardId: 6, // TODO: will be TitleCase if it comes from the DB
    Name: 'SalesRepCustomerApprovalRequests',
    DisplayName: 'Customer Approval Requests',
    Entity: 'User', // TODO: this should be more about what to call to get the results
    Method: 'getCustomerApprovals',
    Filter: {},
    CardClass: 'col-6',
    fields: [
      { label: 'Customer No', class: '', key: 'CustomerNumber' },
      { label: 'Pending Requests', class: '', key: 'PendingCustomerPermissionRequests' },
    ],
    results: _.clone(blankResponseArray),
  }

  public dashboardShippedOrders = {
    DashboardId: 7, // TODO: will be TitleCase if it comes from the DB
    Name: 'ShippedOrders',
    DisplayName: 'Shipped Sales Orders',
    Entity: 'Order', // TODO: this should be more about what to call to get the results
    Method: 'getFilteredOrders',
    Filter: { orderStatus: OrderStatus.SHIPPED, pageSize: 10 },
    CardClass: 'col-12',
    fields: [
      {
        label: 'Order Date',
        class: '',
        thClass: 'pl-3',
        key: 'OrderDate',
        formatter: () => {
          return ''
        },
      },
      { label: 'Order/PO', class: '', key: 'SalesOrderNumber' },
      { label: 'Customer', class: '', key: 'CustomerNumber' },
      { label: 'Ship To', class: '', key: 'ShipToParty' },
      {
        key: 'Deliveries',
        label: 'Ship Via',
        thClass: 'responsive-col text-left',
        tdClass: 'responsive-col text-left',
        formatter: (deliveries: any) => {
          return deliveries[0]?.Carrier ?? ''
        },
      },
      { label: 'Amount', class: 'text-sm-right', key: 'Total', formatter: (val: string) => this.formatPrice(val) },
    ],
    results: _.clone(blankResponseArray),
  }

  public dashboardShippingIn10DayOrders = {
    DashboardId: 8,
    Name: 'ShippingOrders',
    DisplayName: 'Shipment',
    Entity: 'Order',
    Method: 'getFilteredOrders',
    Filter: { orderStatus: OrderStatus.ALL, shippingInDay: 10 },
    CardClass: 'col-12',
    fields: [
      {
        label: 'Order Date',
        class: '',
        thClass: 'pl-3',
        key: 'OrderDate',
        formatter: () => {
          return ''
        },
      },
      { label: 'Order/PO', class: '', key: 'SalesOrderNumber' },
      { label: 'Expected Shipping Date', class: '', key: 'ExpectedShippingDate', formatter: (val: string) => dayjs(val).format('YYYY-MM-DD') },
      // { label: 'PO', class: '', key: 'CustomerPurchaseOrderNumber' },
      { label: 'Customer', class: '', key: 'CustomerNumber' },
      { label: 'Ship To', class: '', key: 'ShipToParty' },
      // { label: 'Sales Reps', class: '', key: 'SalesRepresentatives' },
      { label: 'Amount', class: 'text-sm-right', key: 'Total', formatter: (val: string) => this.formatPrice(val) },
    ],
    results: _.clone(blankResponseArray),
  }

  public dashboardInquiryPending = {
    DashboardId: 8,
    Name: 'PendingInquiries',
    DisplayName: 'Inquiries',
    Entity: 'Inquiry',
    Method: 'getFilteredInquiries',
    Filter: { },
    CardClass: 'col-12',
    fields: [
      { label: 'Inquiry No', class: 'p-2 pl-3', key: 'InquiryId' },
      { label: 'Inquiry Date', class: 'p-2 pl-3', key: 'InquiryDate', formatter: (val: string) => dayjs(val).format('YYYY-MM-DD') },
      { label: 'Customer', class: '', key: 'Customer' },
      { label: 'Material / Description', class: '', key: 'Material' },
      { label: 'Amount', class: 'text-sm-right', key: 'Total', formatter: (val: string) => this.formatPrice(val) },
    ],
    results: _.clone(blankResponseArray),
  }

  public async getFilteredOrders(filter: any) {
    // filters
    const filters = _.assign({}, blankSearchFilters, {
      page: 1,
      pageSize: 100,
      orderStatus: OrderStatus.PENDING,
      // poNumber: 'ReplacementParts',
      sortBy: {
        by: 'OrderDate',
        desc: true,
      },
      sortDesc: true,
      saveFilters: false,
    }, filter)
    const orders = await this.getOrders(filters)
    if (orders.List) {
      return {
        Total: orders.List.length,
        List: orders.List,
      }
    } else {
      return []
    }
  }

  public async getFilteredInquiries(filter: any) {
    // filters
    const filters = _.assign({}, blankInquiryFilters, {
      page: 1,
      pageSize: 100,
    }, filter)
    const orders = await this.getInquiries(filters)
    if (orders.List) {
      return {
        Total: orders.List.length,
        List: orders.List,
      }
    } else {
      return []
    }
  }

  public async getSalesRepApprovals() {
    const results = await this.api.fetchV2({ url: '/sales-rep?PageSize=100&Page=1&SortBy=PermissionRequests&SortDirection=desc&salesRepNumber=&salesRepName=&filterByHasUsers=false&filterByHasPendingPermissions=true' })
    return {
      Total: results.List?.length,
      List: results.List,
    }
  }

  public onApproveSalesRep(item: any) {
    this.salesRepRequestToApprove = item
    this.showSalesRepApproveModal = true
  }

  public approvePermissionSalesRep() {
    this.api.fetchV2({
      url: '/sales-rep/permission-requests/batchRespond',
      obj: { isApproved: true, PermissionIds: [this.salesRepRequestToApprove?.Id] },
      method: HttpMethod.Post,
    }).then((response : TPIException) => {
      if (response.Successful) {
        this.toastSuccess('Updated successfully')
        // TODO: refresh just one
        this.refreshDashboard('SalesRepApprovalRequests')
      } else {
        this.toastError(response.Message)
      }
    })
  }

  public onRejectSalesRep(item: any) {
    this.rejectionReason = null
    this.salesRepRequestToReject = item
    this.showSalesRepRejectionModal = true
  }

  public rejectPermissionSalesRep() {
    const obj = { isApproved: false, rejectionStatus: this.rejectionReason, PermissionIds: [this.salesRepRequestToReject?.Id] }
    this.api.fetchV2({
      url: '/sales-rep/permission-requests/batchRespond',
      obj,
      method: HttpMethod.Post,
    }).then((response : TPIException) => {
      if (response.Successful) {
        this.toastSuccess('Updated successfully')
        // TODO: refresh just one
        this.refreshDashboard('SalesRepApprovalRequests')
      } else {
        this.toastError(response.Message)
      }
    })
  }

  public onRejectCustomer(item: any) {
    this.rejectionReason = null
    this.customerRequestToReject = item
    this.showCustomerRejectionModal = true
  }

  public rejectPermissionCustomer() {
    this.rejectPermissionCustomerAction({ rejectionReason: this.rejectionReason, permissionId: this.customerRequestToReject?.Id })
      .then((response : TPIException) => {
        if (response.Successful) {
          this.toastSuccess('Updated successfully')
          this.refreshDashboard('CustomerApprovalRequests')
          this.refreshDashboard('SalesRepCustomerApprovalRequests')
        } else {
          this.toastError(response.Message)
        }
      })
  }

  public onApproveCustomer(item: any) {
    this.customerRequestToApprove = item
    this.showCustomerApproveModal = true
  }

  public approvePermissionCustomer() {
    this.approvePermissionCustomerAction(this.customerRequestToApprove?.Id)
      .then((response : TPIException) => {
        if (response.Successful) {
          this.toastSuccess('Updated successfully')
          this.refreshDashboard('CustomerApprovalRequests')
          this.refreshDashboard('SalesRepCustomerApprovalRequests')
        } else {
          this.toastError(response.Message)
        }
      })
  }

  public mounted() {
    this.hideBreadcrumbDisplay(true)
    this.refreshDashboard()
  }

  public refreshDashboard(name?: string) {
    const dashboards = name
      ? this.dashboards.filter(d => d.Name === name)
      : this.dashboards
    dashboards.forEach(dashboard => {
      Vue.set(dashboard, 'loading', true)
      this[dashboard.Method](dashboard.Filter).then(results => {
        Vue.set(dashboard, 'results', results)
        Vue.set(dashboard, 'loading', false)
      })
    })
    setTimeout(this.refreshDashboard, 3000000)
  }

  public formatPrice = (value) => {
    return (
      '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 })
    )
  }

  public getResultCount(dashboard) {
    if (dashboard.loading) {
      return 'Loading...'
    }
    return dashboard.results.Total + ' results'
  }

  public isValidRejectionReason() {
    return this.rejectionReason && this.rejectionReason !== ''
  }

  public _isCustomerAdminSite() {
    return isCustomerAdminSite(this.role)
  }

  public setSelectedShippingInformation(information: ShippingInformation, trackingNumber: string) {
    this.selectedTrackingNumber = trackingNumber
    this.selectedShippingInformation = information
  }
}
</script>
<style>
.loading-card {
  height: 300px;
  display: flex;
  justify-content: center;
}

.card-body {
  min-height: 200px;
}
</style>
